/**
 * Convert enriched `GET /listing-layout-links?includeLayout=1` layout snapshots
 * into getByPartner-shaped rows for normalizePartnerLayout / tree builders.
 */
export function partnerLayoutRowFromEnrichedLink(layout) {
  if (!layout || !layout._id) return null;
  return {
    _id: layout._id,
    uuid: layout.uuid,
    name: layout.name,
    createdAt: layout.createdAt,
    rootLayoutUuid: layout.rootLayoutUuid,
    thumbnailImage:
      layout.thumbnail ||
      layout.thumbnailImage ||
      layout.image ||
      null,
    thumbnailfurnishedImageId:
      layout.furnishedThumbnail ||
      layout.thumbnailfurnishedImageId ||
      layout.furnishedImageId ||
      null,
    furnishedImageId: layout.furnishedImageId || layout.furnishedThumbnail || null,
    image: layout.image || layout.thumbnail || layout.thumbnailImage || null,
    baseCopiedFrom: layout.baseCopiedFrom || null,
    immediateCopiedFrom: layout.immediateCopiedFrom || null,
    parent: layout.parent || null,
    user: layout.user || null,
  };
}

/** Build flat getByPartner-shaped roots from enriched listing links. */
export function linkedCatalogFromListingLinks(listingLinks) {
  if (!Array.isArray(listingLinks) || listingLinks.length === 0) return [];
  const seen = new Set();
  const rows = [];
  listingLinks.forEach((link) => {
    const uuid = link?.layoutUuid;
    if (!uuid || seen.has(uuid)) return;
    const row = partnerLayoutRowFromEnrichedLink(link?.layout);
    if (!row) return;
    seen.add(uuid);
    rows.push(row);
  });
  return rows;
}

export function hasEnrichedLinkedCatalog(listingLinks) {
  if (!Array.isArray(listingLinks) || listingLinks.length === 0) return false;
  return listingLinks.some((link) => link?.layout?._id);
}

/** Merge date-scoped catalog rows with enriched linked rows (linked wins on uuid). */
export function mergeCatalogWithLinkedLayouts(catalogRows, linkedRows) {
  const byUuid = new Map();
  (Array.isArray(linkedRows) ? linkedRows : []).forEach((row) => {
    if (row?.uuid) byUuid.set(String(row.uuid), row);
  });
  (Array.isArray(catalogRows) ? catalogRows : []).forEach((row) => {
    const uuid = row?.uuid;
    if (!uuid || byUuid.has(String(uuid))) return;
    byUuid.set(String(uuid), row);
  });
  return Array.from(byUuid.values());
}
